import { useCallback, useState } from 'react';
import { ChatComposer } from './ChatComposer';
import styles from './ChatSuggestedPrompts.module.css';

export const SUGGESTED_CHAT_PROMPTS = [
  'What is my net worth?',
  'Summarize my portfolio',
  'Which portfolio companies need attention?',
  'Where should I consider following on?',
  'Any high-interest debt?',
  'Recent bank outflows',
] as const;

export type ChatSuggestedPromptsProps = {
  onSelect: (prompt: string) => void;
  disabled?: boolean;
};

export function ChatSuggestedPrompts({ onSelect, disabled = false }: ChatSuggestedPromptsProps) {
  return (
    <div className={styles.panel} role="group" aria-label="Suggested questions">
      {SUGGESTED_CHAT_PROMPTS.map((prompt) => (
        <button
          key={prompt}
          type="button"
          className={styles.chip}
          disabled={disabled}
          onClick={() => onSelect(prompt)}
        >
          {prompt}
        </button>
      ))}
    </div>
  );
}

export type ChatComposerWithSuggestedPromptsProps = {
  messageCount: number;
  loading?: boolean;
  onSend: (message: string) => void;
};

export function ChatComposerWithSuggestedPrompts({
  messageCount,
  loading = false,
  onSend,
}: ChatComposerWithSuggestedPromptsProps) {
  const [draft, setDraft] = useState('');
  const showPrompts = messageCount === 0;

  const handleSend = useCallback(() => {
    const trimmed = draft.trim();
    if (!trimmed || loading) return;
    onSend(trimmed);
    setDraft('');
  }, [draft, loading, onSend]);

  return (
    <div className={styles.footer}>
      {showPrompts ? (
        <ChatSuggestedPrompts onSelect={setDraft} disabled={loading} />
      ) : null}
      <ChatComposer
        value={draft}
        onChange={setDraft}
        onSend={handleSend}
        loading={loading}
      />
    </div>
  );
}
